import { forwardRef } from 'react';
import clsx from 'clsx';

import { ArrowRightIcon } from '@/components/svg-icons';

export const EventButton = forwardRef<
	HTMLButtonElement,
	React.ComponentPropsWithRef<'button'>
>(function EventButton(
	{ 
		className = 'reward-btn--primary', 
		children, 
		...buttonProps 
	},
	ref
) {
	return (
		<button 
			ref={ref}
			className={clsx('reward-btn', className)} 
			type="button" 
			{...buttonProps}
		>
			<div className="reward-btn__info">
				<span className="reward-btn__text">{children}</span>
			</div>
			<ArrowRightIcon />
		</button>
	);
});